import React, { Fragment } from 'react';
import { AppRegistry } from 'react-native';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ElTiempoHeader, EroskiHeader } from './components';
import { C } from './common';
import { ENV, THEME } from './reactor/common';
import CUSTOM_THEME from './common/theme';
import onElTiempoDomain from './common/onElTiempoDomain';
import onEroskiDomain from './common/onEroskiDomain';

THEME.extend(CUSTOM_THEME);

const App = require('./App').default;

const language = C.DOMAINS[window.location.host.split('.')[2]];
const loadedOnEltiempoDomain = onElTiempoDomain();
const loadedOnEroskiDomain = onEroskiDomain();

const Browser = () => (
  <BrowserRouter>
    <Switch>
      <Route
        exact
        path="/story/:uri"
        render={
          ({ match }) => (
            <Fragment>
              { loadedOnEltiempoDomain && (
                <ElTiempoHeader />
              )}
              { loadedOnEroskiDomain && (
                <EroskiHeader />
              )}
              <App language={language} story={match.params.uri} />
            </Fragment>
          )
        }
      />
      <Route
        exact
        path="/:uri"
        render={
          ({ match }) => (
            <Fragment>
              { loadedOnEltiempoDomain && (
                <ElTiempoHeader />
              )}
              <App language={language} story={match.params.uri} />
            </Fragment>
          )
        }
      />
    </Switch>
  </BrowserRouter>
);

AppRegistry.registerComponent('App', () => Browser);
AppRegistry.runApplication('App', {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
